// 1. IMPORTS
import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import axios from 'axios'
import { QueryClient, QueryClientProvider } from 'react-query'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './i18n/config'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider, setupAxios } from './app/modules/auth'
import { Provider } from 'react-redux'
import { store } from './app/store'
import { registerLicense } from '@syncfusion/ej2-base'
import CacheBuster from 'react-cache-buster'
import Loader from './common/Loader'
import ExtensionContainer from './features/extension/ExtensionContainer'

// 2. METRONIC THEME SETUP (CSP Safe)
let themeMode = 'system'
if (localStorage.getItem('kt_theme_mode_value')) {
  themeMode = localStorage.getItem('kt_theme_mode_value') || 'system'
}
if (themeMode === 'system') {
  themeMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}
document.documentElement.setAttribute('data-bs-theme', themeMode)

// 3. INITIALIZATIONS
declare const chrome: any

setupAxios(axios)
registerLicense('Ngo9BigBOggjHTQxAR8/V1NGaF5cXmpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWXhcdXRWR2hZU0V1V0c=')

const version = process.env.REACT_APP_VERSION
const isProduction = process.env.NODE_ENV === 'production'
const queryClient = new QueryClient()

// 4. ENVIRONMENT DETECTION
const container = document.getElementById('root') || document.getElementById('extension-root')

const isExtensionEnvironment =
  typeof chrome !== 'undefined' &&
  chrome.runtime &&
  chrome.runtime.id &&
  window.location.protocol.includes('chrome-extension')

// 5. BACKWARD-COMPATIBLE MOUNT FUNCTION
const mountApp = (ui: React.ReactElement, containerElement: HTMLElement) => {
  if (typeof createRoot === 'function') {
    // React 18+
    const root = createRoot(containerElement)
    root.render(ui)
  } else {
    // React 17 and below fallback
    ReactDOM.render(ui, containerElement)
  }
}

// 6. RENDER LOGIC
if (container) {
  if (isExtensionEnvironment) {
    mountApp(
      <Provider store={store}>
        <ExtensionContainer />
      </Provider>,
      container
    )
  } else {
    mountApp(
      <CacheBuster
        currentVersion={version}
        isEnabled={isProduction}
        isVerboseMode={false}
        loadingComponent={<Loader />}
        metaFileDirectory={'.'}
      >
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            <AuthProvider>
              <Provider store={store}>
                <AppRoutes />
              </Provider>
            </AuthProvider>
          </MetronicI18nProvider>
        </QueryClientProvider>
      </CacheBuster>,
      container
    )
  }
}